namespace Nobox.Administration {
    export interface SettingTenantForm {
        Nm: Serenity.StringEditor;
        Id: Serenity.StringEditor;
        IsDlt: Serenity.IntegerEditor;
        Email: Serenity.StringEditor;
        Phone: Serenity.StringEditor;
        IdtryId: Serenity.ServiceLookupEditor;
        IdtryNm: Serenity.StringEditor;
        SzId: Serenity.ServiceLookupEditor;
        InvCdGen: Serenity.StringEditor;
        SzNm: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        CtryId: Serenity.ServiceLookupEditor;
        StatesId: Serenity.ServiceLookupEditor;
        CityId: Serenity.ServiceLookupEditor;
        ZipCode: Serenity.StringEditor;
        Ctry: Serenity.StringEditor;
        States: Serenity.StringEditor;
        City: Serenity.StringEditor;
        ChannelId: Serenity.ServiceLookupEditor;
        AccountIds: Serenity.ServiceLookupEditor;
        AccountEmail: Serenity.ServiceLookupEditor;
        PipelineId: Serenity.ServiceLookupEditor;
        StageId: Serenity.ServiceLookupEditor;
        IsAutoResolve: Serenity.BooleanEditor;
        RHours: Serenity.IntegerEditor;
        RMinutes: Serenity.IntegerEditor;
        IsAutoArchive: Serenity.BooleanEditor;
        AHours: Serenity.IntegerEditor;
        AMinutes: Serenity.IntegerEditor;
        Note: Serenity.TextAreaEditor;
        TenantMembers: TenantMemberEditor;
        Division: TenantDivisionEditor;
        TenantIntegration: TenantIntegrationEditor;
        Sunday: Serenity.BooleanEditor;
        fSunday: CustomTimePickerEditor;
        lSunday: CustomTimePickerEditor;
        nSunday: Serenity.Extensions.StaticTextBlock;
        Monday: Serenity.BooleanEditor;
        fMonday: CustomTimePickerEditor;
        lMonday: CustomTimePickerEditor;
        nMonday: Serenity.Extensions.StaticTextBlock;
        Tuesday: Serenity.BooleanEditor;
        fTuesday: CustomTimePickerEditor;
        lTuesday: CustomTimePickerEditor;
        nTuesday: Serenity.Extensions.StaticTextBlock;
        Wednesday: Serenity.BooleanEditor;
        fWednesday: CustomTimePickerEditor;
        lWednesday: CustomTimePickerEditor;
        nWednesday: Serenity.Extensions.StaticTextBlock;
        Thursday: Serenity.BooleanEditor;
        fThursday: CustomTimePickerEditor;
        lThursday: CustomTimePickerEditor;
        nThursday: Serenity.Extensions.StaticTextBlock;
        Friday: Serenity.BooleanEditor;
        fFriday: CustomTimePickerEditor;
        lFriday: CustomTimePickerEditor;
        nFriday: Serenity.Extensions.StaticTextBlock;
        Saturday: Serenity.BooleanEditor;
        fSaturday: CustomTimePickerEditor;
        lSaturday: CustomTimePickerEditor;
        nSaturday: Serenity.Extensions.StaticTextBlock;
        During: Serenity.BooleanEditor;
        DuringMsg: Serenity.TextAreaEditor;
        Outside: Serenity.BooleanEditor;
        OutsideMsg: Serenity.TextAreaEditor;
    }

    export class SettingTenantForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SettingTenant';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SettingTenantForm.init)  {
                SettingTenantForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.TextAreaEditor;
                var w5 = TenantMemberEditor;
                var w6 = TenantDivisionEditor;
                var w7 = TenantIntegrationEditor;
                var w8 = CustomTimePickerEditor;
                var w9 = s.Extensions.StaticTextBlock;

                Q.initFormType(SettingTenantForm, [
                    'Nm', w0,
                    'Id', w0,
                    'IsDlt', w1,
                    'Email', w0,
                    'Phone', w0,
                    'IdtryId', w2,
                    'IdtryNm', w0,
                    'SzId', w2,
                    'InvCdGen', w0,
                    'SzNm', w0,
                    'Address', w0,
                    'CtryId', w2,
                    'StatesId', w2,
                    'CityId', w2,
                    'ZipCode', w0,
                    'Ctry', w0,
                    'States', w0,
                    'City', w0,
                    'ChannelId', w2,
                    'AccountIds', w2,
                    'AccountEmail', w2,
                    'PipelineId', w2,
                    'StageId', w2,
                    'IsAutoResolve', w3,
                    'RHours', w1,
                    'RMinutes', w1,
                    'IsAutoArchive', w3,
                    'AHours', w1,
                    'AMinutes', w1,
                    'Note', w4,
                    'TenantMembers', w5,
                    'Division', w6,
                    'TenantIntegration', w7,
                    'Sunday', w3,
                    'fSunday', w8,
                    'lSunday', w8,
                    'nSunday', w9,
                    'Monday', w3,
                    'fMonday', w8,
                    'lMonday', w8,
                    'nMonday', w9,
                    'Tuesday', w3,
                    'fTuesday', w8,
                    'lTuesday', w8,
                    'nTuesday', w9,
                    'Wednesday', w3,
                    'fWednesday', w8,
                    'lWednesday', w8,
                    'nWednesday', w9,
                    'Thursday', w3,
                    'fThursday', w8,
                    'lThursday', w8,
                    'nThursday', w9,
                    'Friday', w3,
                    'fFriday', w8,
                    'lFriday', w8,
                    'nFriday', w9,
                    'Saturday', w3,
                    'fSaturday', w8,
                    'lSaturday', w8,
                    'nSaturday', w9,
                    'During', w3,
                    'DuringMsg', w4,
                    'Outside', w3,
                    'OutsideMsg', w4
                ]);
            }
        }
    }
}
